import { Button } from "react-bootstrap";
import OrderQueue from "./OrderQueue";
import OrderSourceCard from "./OrderSourceCard";
import OrderWorkspaceHeader from "./OrderWorkspaceHeader";
import styles from "./OrdersWorkspace.module.css";

export default function OrdersWorkspace({ orders, selectedOrder, selectedOrderId, onSelectOrder, onMobileBack, mobileOrderOpen, totalOrders, actionProps, sourceActionProps }) {
  return (
    <div className={`${styles.workspace} ${mobileOrderOpen ? styles.mobileDetailOpen : ""}`}>
      <OrderQueue orders={orders} selectedOrderId={selectedOrderId} onSelectOrder={onSelectOrder} totalOrders={totalOrders} />
      <section className={styles.detail} aria-label="Selected order workspace">
        <Button className={`${styles.mobileBack} d-md-none`} variant="link" onClick={onMobileBack}>Back to Orders</Button>
        <OrderWorkspaceHeader order={selectedOrder} {...actionProps} />
        <div className={styles.sourceList}>{(selectedOrder?.order_sources || []).map((source) => <OrderSourceCard key={source.order_source_id} order={selectedOrder} source={source} {...sourceActionProps} />)}</div>
      </section>
    </div>
  );
}
